import { useState } from "react"
import { faClose, faPalette } from "@fortawesome/free-solid-svg-icons"
import Button, { ButtonIcon } from "../../../components/Button/Button"
import ModalPortal from "../../../components/Modal/ModalPortal"
import { TitlePageResponsiveIconSmall } from "../../../components/Titles/Titles"
import THEME from "../../../configuration/Theme"
import { SIZE } from "../../../configuration/Sizes"
import defaultStyle from "../../../styles/defaultPageStyle.module.css"
import { useTranslation } from "react-i18next"
import InputField from "../../../components/InputField/InputField"
import Animate, { AnimationTypes } from "../../../components/Animate/Animate"

interface Props {
  initialName?: string
  onClose: () => void
  onConfirm: (name: string) => void
}

export const PublicMenuThemeNamePopup = ({ initialName = "", onClose, onConfirm }: Props) => {
  const { t } = useTranslation("company")

  const [name, setName] = useState(initialName)

  const normalizedName = name.trim()

  return (
    <ModalPortal>
      <div className={defaultStyle.overlay}>
        <Animate type={AnimationTypes.slideUpIn} duration="0.3s">
          <div className={defaultStyle.alert1}>
            <TitlePageResponsiveIconSmall
              title={t("public_menu_customization.themes.name_popup_title")}
              icon={faPalette}
              iconColor={THEME.colors.iconBGColor}
              children={
                <ButtonIcon
                  sizeNumber={SIZE.buttonCloseIconSize}
                  bgColor={THEME.colors.buttonBGCloseColor}
                  iconColor={THEME.colors.buttonFGCloseColor}
                  icon={faClose}
                  onClick={onClose}
                  size="small"
                  descriptionKey="interactionDescriptions:pages.myRestaurant.myCompany.publicMenuThemeNamePopup.button.onClose"
                />
              }
            />

            <form
              className="mt-4 space-y-4 p-1"
              onSubmit={(event) => {
                event.preventDefault()
                if (normalizedName) onConfirm(normalizedName)
              }}
            >
              <InputField
                type="text"
                value={name}
                icon={faPalette}
                maxLength={80}
                required
                onChange={(event) => setName(event.target.value)}
                placeholder={t("public_menu_customization.themes.name_placeholder")}
                descriptionKey="interactionDescriptions:pages.myRestaurant.myCompany.publicMenuThemeNamePopup.input.namePlaceholder"
              />

              <div className={defaultStyle.divisionBar}></div>

              <div className={defaultStyle.buttonsController}>
                <Button
                  typeButton="submit"
                  disabled={!normalizedName}
                  label={t("public_menu_customization.themes.save_theme")}
                  bgColor={THEME.colors.buttonBGSaveColor}
                  descriptionKey="interactionDescriptions:pages.myRestaurant.myCompany.publicMenuThemeNamePopup.button.saveTheme"
                />
              </div>
            </form>
          </div>
        </Animate>
      </div>
    </ModalPortal>
  )
}
